import type { ReactNode } from 'react';
import { Box, Collapse, Heading, Icon } from '@ksyos/design-system';
import { useEffect, useState } from 'react';

type CollapseCardProps = Readonly<{
    children: ReactNode;
    isInitiallyOpen?: boolean;
    title: string;
}>;

// TODO: CS-25572 Move to Design System
export function CollapseCard({ children, isInitiallyOpen = false, title }: CollapseCardProps) {
    const [isOpen, setIsOpen] = useState(isInitiallyOpen);
    useEffect(() => {
        // if prop is explicitly defined, always use it
        if (isInitiallyOpen !== undefined) {
            setIsOpen(isInitiallyOpen);
        }
    }, [isInitiallyOpen]);

    return (
        <>
            <div data-dd-action-name={`${title} heading`}>
                <Box
                    alignItems="center"
                    display="flex"
                    justifyContent="space-between"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <Heading size="medium">{title}</Heading>
                    <Icon icon={isOpen ? 'caret-up' : 'caret-down'} />
                </Box>
            </div>
            <Collapse isOpen={isOpen}>
                <Box sx={{ paddingY: 3 }}>{children}</Box>
            </Collapse>
        </>
    );
}
